import { MainLayout } from 'shared/ui/layout/main';

import { Tabs } from '../tabs';

export function CarModelsLayout() {
  return <MainLayout tabs={<Tabs />} />;
}
